import React, { useState, useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import APIContext, { APIStore } from './APIContext'

const ComputedDataContext = React.createContext({})
ComputedDataContext.displayName = 'ComputedDataContext'

export default ComputedDataContext

const defaultStart = moment.utc('2010-01-01').format('YYYY-MM-DD')
const defaultEnd = moment.utc().format('YYYY-MM-DD')

const defaultInterval = { start: defaultStart, end: defaultEnd }

const computedMetadata = (metaData) => {
  const {
    last_interval: lastInterval = defaultInterval,
    full_interval: fullInterval = defaultInterval,
    current_soiling_rate: currentSoilingRate = 0,
    day_soiling_average_rate: daySoilingAverageRate = 0,
    last_cleaning_not_generation: notGeneratedLastCleaningMWh = 0,
  } = metaData
  return {
    ...metaData,
    currentSoilingRate: +currentSoilingRate.toFixed(2),
    daySoilingAverageRate: +daySoilingAverageRate.toFixed(2),
    notGeneratedLastCleaningMWh: +(notGeneratedLastCleaningMWh / 1000).toFixed(2),
    lastInterval: { start: moment.utc(lastInterval.start, 'YYYY-MM-DD'), end: moment.utc(lastInterval.end, 'YYYY-MM-DD') },
    fullInterval: { start: moment.utc(fullInterval.start, 'YYYY-MM-DD'), end: moment.utc(fullInterval.end, 'YYYY-MM-DD') },
  }
}


const LocalStore = ({ children }) => {
  const {
    centralsMetaData: centralsMetaDataApi,
    centralsData: centralsDataApi,
    resetCleanings,
  } = useContext(APIContext)
  const [centralsMetaData, setCentralsMetadata] = useState({})

  useEffect(() => {
    const CentralsData = Object.values(centralsDataApi)
    if (CentralsData.length === 0) return
    const metaData = Object.values(centralsMetaDataApi).sort((a, b) => {
      return a.fancy_name.localeCompare(b.fancy_name);
    });
    if (metaData.length === 0) return
    setCentralsMetadata(
      metaData
        .map((value) => computedMetadata(value))
        .reduce((prev, current) => ({
          ...prev,
          [current.id]: {
            ...current,
            resetCleanings: () => { resetCleanings(current.id) },
          },
        }), {}),
    )
  }, [centralsDataApi, centralsMetaDataApi, resetCleanings])
  return (
    <ComputedDataContext.Provider value={{ centralsMetaData, centralsData: centralsDataApi, setCentralsMetadata }}>
      {children}
    </ComputedDataContext.Provider>
  )
}
const ComputedDataStore = ({ children }) => (
  <APIStore>
    <LocalStore>
      { children }
    </LocalStore>
  </APIStore>
)

LocalStore.propTypes = { children: PropTypes.node.isRequired }
ComputedDataStore.propTypes = { children: PropTypes.node.isRequired }
export { ComputedDataStore }
